var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full-height"},[_c('crud-layout',{ref:"crudLayout",attrs:{"name":_vm.name,"interface":_vm.interface,"id":_vm.id,"page":_vm.page}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }